import { Link } from 'react-router-dom';
import './PolicyPages.css';

const PrivacyPolicy = () => {
  return (
    <>
      {/* Page Title */}
      <div className="page-title-area ptb-100">
        <div className="container">
          <div className="page-title-content">
            <h1>Privacy Policy</h1>
            <ul>
              <li className="item"><Link to="/">Home</Link></li>
              <li className="item"><i className="flaticon-play-button"></i> Privacy Policy</li>
            </ul>
          </div>
        </div>
        <div className="bg-image">
          <img src="/assets/img/page-title/page-title-bg.jpg" alt="Privacy Policy" />
        </div>
      </div>

      {/* Privacy Policy Content */}
      <section className="privacy-policy-area ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-12">
              <div className="privacy-sidebar">
                <ul>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/terms">Terms Of Service</Link></li>
                  <li className="active"><Link to="/privacy">Privacy And Policy</Link></li>
                </ul>
              </div>
            </div>
            
            <div className="col-lg-9 col-md-12">
              <div className="privacy-content">
                <p className="update-date">This Privacy Policy was last updated on October, 2024.</p>
                
                <h2>Privacy Policy</h2>
                <p>
                  How to inform user / customer(s) that www.desalepatil.in is the only official website of Desale Patil Developers. User off-sites and subsidiaries (the-matter collectively referred to as "Company").
                </p>
                <p>
                  User/Customer(s) are cautioned and advised not to rely upon any information stated on any other websites which may appear to be similar to the Company's official website. The information contained in such websites may be misleading/false and user/customer(s) may suffer loss if they rely on such information. In the event user/customer(s) come across any such websites similar to Company's official website containing its logo, images, text or any other information then, kindly contact us through email/phone available on website for Company to take necessary action.
                </p>

                <h3>Information Collected from you</h3>
                <p>
                  This Website is made available to visitors by the group for imparting informations. This Website site is concrete facts not been reviewed or approved by any of our affiliates or group companies. This Website does not intend to provide investment, tax or legal advice or commitment or offer of any kind. None of the information or materials accessible through this Website should be construed as providing any type of investment or other advice to you. For should you consider anything on this Website as an offer, recommendation or solicitation to purchase or sell any financial security or to patronize, sell, lease, or provide any other goods or services.
                </p>

                <h3>1. Information Relating to Available Space and Pricing</h3>
                <p>
                  A) We may share your personal information with any member of our group, which means our subsidiaries, our ultimate holding company and its subsidiaries. B) We may share your information with third parties i.e. Business partners, professional advisors etc. for the performance of any contract or any potential contract we may enter into with them or you, or in relation to any ancillary requirements or otherwise; ii. Advertisers and advertising networks that require the data to select and serve relevant advertisements to you and others; and iii. Analytics and search engine providers that assist us in the improvement and optimization of our sites.
                </p>

                <h3>Where we store your personal data</h3>
                <p>
                  The data that we collect from you may be transferred, stored and processed by staffs who work for us. Such staff maybe engaged in, among other things, the fulfillment of your enquiry and the provision of support services. By submitting your personal data, you agree to this transfer, storing or processing. We will take all steps reasonably necessary to ensure that your data is treated securely.
                </p>

                <h3>2. Security</h3>
                <p>
                  We are committed to ensuring that your information is secure. In order to prevent unauthorized access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.
                </p>

                <h3>3. Changes to Privacy Policy</h3>
                <p>
                  We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page. You are advised to review this Privacy Policy periodically for any changes.
                </p>

                <h3>4. Contact Us</h3>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:
                </p>
                <ul>
                  <li><strong>Email:</strong> info@desalepatil.in</li>
                  <li><strong>Phone:</strong> +91 9823020019</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
